import moment from 'moment';
import { combineReducers } from 'redux';
import { loadState } from './localStorage';

const date = (state = moment().add(2, 'days').format('YYYY-MM-DD'), action) => {
	switch (action.type) {
	case 'LIST_MEETINGS':
		return action.date;
	default:
		return state;
	}
};

const connection = (state = true, action) => {
	switch (action.type) {
	case 'socket/connect':
		return action.connection;
	default:
		return state;
	}
};

const agency = (state = 'tab', action) => {
	switch (action.type) {
	case 'agency/select':
		return action.agency;
	case 'agency/toggle':
		return state === 'tab' ? 'ubet' : 'tab';
	default:
		return state;
	}
};

const progressCheck = (state = {meetings: false}, action) => {
	switch (action.type) {
	case 'updating/meetings':
		return {
			...state,
			meetings: true
		};
	case 'LIST_MEETINGS':
		return {
			...state,
			meetings: false
		};
	default:
		return state;
	}
};

const meetings = (state = [], action) => {
	switch (action.type) {
	case 'LIST_MEETINGS':
		return action.meetings;

	case 'meeting/new': {
		let newMeetings = [...state];
		try {
			const selectedDate = loadState() ? loadState().date : undefined;

			if (selectedDate) {
				if (action.meeting.date === selectedDate) {
					// first, filter out any meetings already at this track, to avoid duplicates (might happen if the meeting is deleted but the socket doesn't send the DEL_MEETING request somehow)
					newMeetings = state.filter(meeting => meeting.venue !== action.meeting.venue);

					newMeetings.push(action.meeting);
				}
			}
		} catch (e) {
			console.log(e);
		}

		return newMeetings;
	}
	case 'currentmeeting/delete':
	case 'meeting/delete': {
		const newMeetings = state.filter(meeting => meeting.id !== action.id);

		return newMeetings;
	}
	case 'meeting/update': {
		const newMeetings = state.map(meeting => {
			if (meeting.id !== action.meeting.id) return meeting;

			return {
				...meeting,
				disabled: false,
				...action.meeting,
			};
		});

		return newMeetings;
	}
	case 'SELECT_DATE':
		return action.meetings;
	default:
		return state;
	}
};

export const reducer = combineReducers({
	date,
	connection,
	agency,
	meetings,
	progressCheck,
});



/** WEBPACK FOOTER **
 ** ./src/reducers.js
 **/